import { Outlet, Route } from 'react-router-dom'
import { IsAffiliate, IsAffiliateManager, RequireAuth } from '~/components/Auth'
import { AffiliateApplyPage } from './AffiliateApplyPage'
import { AffiliateLandingPage } from './AffiliateLandingPage'
import { AffiliateManagerToolsPage } from './AffiliateManagerToolsPage'
import { AffiliateToolsPage } from './AffiliateToolsPage'

/**
 * `/affiliate/*`.
 *
 * The index is public on purpose — it is the page a creator gets sent in a DM, and
 * it has to survive being opened by someone with no BR1 account. Everything under
 * it is gated: applying needs an account, and the tools page needs an approved
 * affiliate.
 *
 * `RequireAuth` wraps `IsAffiliate` rather than the other way round, because the
 * affiliate flag only exists on an authenticated viewer — checked the other way, a
 * signed-out visitor would fall through to the 403 page instead of the login they
 * actually need.
 */
export const AffiliateRoutes = [
    <Route key='affiliate' element={<Outlet />}>
        <Route index element={<AffiliateLandingPage />} />
        <Route
            path='apply'
            element={
                <RequireAuth fallback='/signup'>
                    <AffiliateApplyPage />
                </RequireAuth>
            }
        />
        <Route
            path='manager-tools'
            element={
                <RequireAuth>
                    <IsAffiliateManager show403={true}>
                        <AffiliateManagerToolsPage />
                    </IsAffiliateManager>
                </RequireAuth>
            }
        />
        <Route
            path='tools'
            element={
                <RequireAuth>
                    <IsAffiliate show403={true}>
                        <AffiliateToolsPage />
                    </IsAffiliate>
                </RequireAuth>
            }
        />
    </Route>,
]
